// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDownRectangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down-rectangle': IconArrowDownRectangle;
    }
}

/**
 * The icon component for the 'arrowDownRectangle' icon
 */
export class IconArrowDownRectangle extends IconSvg {
    public constructor() {
        super(arrowDownRectangle16X16);
    }
}

registerIconSvg('icon-arrow-down-rectangle', IconArrowDownRectangle);
export const iconArrowDownRectangleTag = 'nimble-icon-arrow-down-rectangle';
